module.exports = __webpack_public_path__ + "images/aixamd94a45b89d66830a01644f62a103d904.png";